import React, {Component, Fragment} from 'react';
import I18n from 'app/i18n';
import {inject, observer} from 'mobx-react';
import {computed} from 'mobx';

import {checkingPages, contentOnly, isDesktop, isGuest} from 'app/utils';
import {goToLinkSimpleBets} from 'app/utils/app_links';
import logEvent from 'app/amplitude/log_event';
import {setStreamsTimeout, showMoreStreams} from 'app/components/streams/stream_functions';
import Stream from 'app/components/streams/stream';
import StreamPopup from 'app/components/streams/stream_popup';
import {streamStore} from 'app/store/global';
import ButtonMoreLess from './button_more_less';
import {openAddStreamPopup} from 'app/components/streams';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {openAuth} from 'app/components/auth/auth';

const CLOSED_STREAM_LIMIT = 6;

export default inject('streamStore', 'userStore')(observer(class StreamsPlayPage extends Component {
    constructor() {
        super();
        this.closeStreamHandler = this.closeStreamHandler.bind(this);
        this.state = {
            visibleCount: CLOSED_STREAM_LIMIT
        };
    }

    rootElement = React.createRef();

    transElement = React.createRef();

    @computed get streams() {
        const {streams, userStreams} = this.props.streamStore;
        return [...streams, ...userStreams];
    }

    @computed get visibleStreams() {
        return this.streams.slice(0, this.state.visibleCount);
    }

    componentDidMount() {
        this.showMoreHandler();
        setStreamsTimeout();
        this.transElement?.current?.addEventListener('transitionend', this.handleTransitionEnd);
    }

    componentWillUnmount() {
        this.transElement?.current?.removeEventListener('transitionend', this.handleTransitionEnd);
    }

    handleTransitionEnd = e => {
        if (e.propertyName !== 'max-height') {
            return;
        }

        if (!this.props.streamStore.opened) {
            this.setState({visibleCount: CLOSED_STREAM_LIMIT});
        }
    };

    onOpen = () => {
        this.setState({visibleCount: this.streams.length});
    };

    componentDidUpdate(prevProps, prevState) {
        const streamsChanged = prevProps.streamStore.streams !== this.props.streamStore.streams ||
                               prevProps.streamStore.userStreams !== this.props.streamStore.userStreams;
        const visibleCountChanged = prevState.visibleCount !== this.state.visibleCount;

        if (streamsChanged || visibleCountChanged) {
            this.showMoreHandler();
        }
    }

    showMoreHandler() {
        showMoreStreams(this.rootElement.current);
    }

    openStreamHandler = stream => {
        logEvent('STREAM_OPENED');
        if (checkingPages.isHomePage()) {
            goToLinkSimpleBets();
        }
        streamStore.chooseStream(stream);
    };

    closeStreamHandler() {
        this.openStreamHandler(null);
    }

    handleStreamCreationPopup = e => {
        e.preventDefault();
        if (isGuest()) {
            openAuth();
        } else {
            openAddStreamPopup();
        }
    };

    render() {
        const {stream, hideQueryParams, opened, imageLastUpdate} = this.props.streamStore;
        const {hiddenStream} = this.props;
        const hasAnyStreams = this.streams.length > 0;
        return <Fragment>
            {stream && <div className="popup-stream" style={{display: 'block'}}>
                <StreamPopup
                    hideQueryParams={hideQueryParams}
                    opened={opened}
                    streams={this.streams}
                    stream={stream}
                    closeStreamHandler={this.closeStreamHandler}
                    hiddenStream={!isDesktop() && hiddenStream}/>
            </div>}
            {isDesktop() && !contentOnly() && !stream && !hiddenStream &&
            <div className="stream-list stream-list--play" ref={this.rootElement}>
                <div className="stream-list__heading">
                    <h2 className="title-h1">{I18n.t('stream_title')}</h2>
                    {hasAnyStreams && <ButtonMoreLess opened={opened} onOpen={this.onOpen}/>}
                </div>
                <div ref={this.transElement}
                    className={`stream-list__streams js-streams-container ${opened
                        ? 'stream-list__streams--expanded'
                        : ''}`}>
                    <div className="stream-list__streams-holder js-streams-maxheight">
                        {this.visibleStreams.map(s => <Stream
                            stream={s}
                            preview="play"
                            key={s.id}
                            imageLastUpdate={imageLastUpdate}
                            userStream={s.author_name === 'by_user_created'}
                            onClick={this.openStreamHandler}
                        />)}
                        <a
                            href="#"
                            data-popup="#stream-add"
                            onClick={this.handleStreamCreationPopup}
                            className="js-streams-minheight media-preview media-preview--play media-preview--add-stream"
                        >
                            <span title={I18n.t('add_your_own')}>
                                <SpriteIcon name="#svg-stream-add" size={{height: 50, width: 50}}/>
                            </span>
                            <span className="media-preview__name">
                                <span className="media-preview__name-text text-center">{I18n.t('add_your_own')}</span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>}
            <div id="dividerStream"/>
            {this.props.children}
        </Fragment>;
    }
}));
